<template>
  <div id="index">
    <el-backtop :bottom="0" :right="0">
      <div
        class="bottom_box"
        style="
           {
            height: 100%;
            width: 100%;
            background-color: #1989fa;
            box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
            text-align: center;
            line-height: 60px;
            color: #f2f5f6;
          }
        "
      >
        <img src="../src/assets/icon5.png" />
      </div>
    </el-backtop>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      setting: {
        title: "",
        keywords: "",
        description: "",
      },
    };
  },
  metaInfo() {
    return {
      title: this.setting.title,
      meta: [
        { name: "keywords", content: this.setting.keywords },
        { name: "description", content: this.setting.description },
      ],
    };
  },
  mounted() {
    this.Init();
  },
  methods: {
    Init() {
      // 在这请求
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_seo",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.setting.title = obj.data.title;
            that.setting.keywords = obj.data.keywords;
            that.setting.description = obj.data.description;
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
};
</script>

<style>
#index {
  background: #fafafa;
}
#index .el-backtop {
  width: 50px;
  height: 60px;
  border-radius: 0;
}

.bottom_box {
  font-size: 0.8rem;
}

.bottom_box::before {
  content: "";
  width: 0px;
  height: 0px;
  border-left: 15px solid transparent;
  border-right: 0px solid transparent;
  border-bottom: 60px solid #1989fa;
  position: absolute;
  top: 0px;
  left: -15px;
}

#index .el-backtop div {
}
@media screen and (max-width: 1340px) {
  .el-picker-panel {
    width: 100%;
    padding: 0 10px;
  }
  .el-date-range-picker .el-picker-panel__body {
    min-width: 345px;
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
  }
  .el-date-range-picker__content {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/Index.vue